import React from 'react';
import TramoViaje from './tramo';
import './paquete-detalle-transporte.css';

const Transporte = (props) => {
  if (
    props.transporte.transporteAereo.itinerarioVuelo.informeIda.segmentoPrincipal.fechaLlegada === '0001-01-01T00:00:00'
        && props.ida.segmentoPrincipal.fechaLlegada === '0001-01-01T00:00:00'
        && props.vuelta.segmentoPrincipal.fechaSalida === '0001-01-01T00:00:00'
        && props.vuelta.segmentoPrincipal.fechaLlegada === '0001-01-01T00:00:00'
  ) {
    return null;
  }

  return (
    <div className='seccion'>
      <h3 className='titulo-seccion'>Transporte</h3>
      <div className='panel panel-default custom bordeado vuelos'>
        <div className='panel-body'>
          <div className='row'>
            <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
              <TramoViaje
                titulo='Ida'
                datos={props.ida}
                transporte={props.transporte.transporteAereo}
              />
            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
              <TramoViaje
                titulo='Vuelta'
                datos={props.vuelta}
                transporte={props.transporte.transporteAereo}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Transporte;
